import { Typography } from "@mui/material";
import React from "react";

const Heading = () => {
  return (
    <>
      <div className="mortgage_calculator_header">
        <Typography
          sx={{
            fontSize: {
              xs: "22px",
              sm: "24.4312px",
              md: "30.2752px",
              lg: "35.1927px",
            },
            color: "#1f1f1f",
            fontWeight: 600,
            fontFamily: "'Archivo',sans-serif",
          }}
          className="refinance_calculator_title table_font "
        >
          Loan Affordability Calculator
        </Typography>
        <Typography
          sx={{
            fontSize: 14,
            lineHeight: "23px",
            fontWeight: 500,
            color: "#1f1f1f",
            fontFamily: "'Archivo',sans-serif",
          }}
        >
          Find out how much loan you can comfortably afford based on your
          current financial profile.
        </Typography>
      </div>
      <div className="line mt-4"></div>
    </>
  );
};

export default Heading;
